export const config = {
  propsName: 'renderProps',
  name: 'SpTmp',
  type: 'formTmpsConfig',
  icon: 'el-icon-setting',
  cnName: 'SpTmp组件',
  tooltip: 'SpTmp模版tooltip',
  base: {
    title: 'SpTmp',
    padded: true,
    flex: '2',
    margin: [0, 0, 0, 0]
  },
  props: [
    {
      // tooltip:'背景图的tooltip',
      type: 'sp-backgroundImg',
      key: 'backgroundImg',
      bind: {
        label: '背景图'
      },
      on: {},
      value: null
    },
    {
      tooltip: '排列方式的tooltip',
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: null
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'color',
      bind: {
        // label: '背景色',
      },
      on: {},
      value: null
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {
        // label: '背景色',
      },
      on: {},
      value: null
    },
    {
      tooltip: '排列方式的tooltip',
      type: () => import('@/weappTmps/comps/flex/index.vue'),
      cmpPath: '/comps/flex/index.vue',
      key: 'flex',
      bind: {
        label: '排列方式'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: null
    },
    {
      tooltip: '模版组件引用的tooltip',
      type: () => import('@/weappTmps/comps/tmp/index.vue'),
      cmpPath: '/comps/tmp/index.vue',
      key: 'tmp',
      bind: {
        label: '模版组件引用'
      },
      on: {},
      value: null
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '标题名称',
        placeholder: '请输入标题名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'defaultVal',
      bind: {
        label: '默认内容',
        placeholder: '请输入默认值'
      },
      value: ''
    },
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: () => import('./comps/test.vue'),
      cmpPath: '/formTmps/SpInput/comps/test.vue',
      key: 'test',
      bind: {
        label: 'import'
      },
      value: null
    },
    {
      render: (h) => {
        return (
          <div class='avatar-wrap'>
            <div class='avatar-icon'>test render</div>
            <div class='avatar-info'>
              <div class='name'>item_name </div>
            </div>
          </div>
        )
      },
      key: 'test2',
      bind: {
        label: 'render'
      },
      value: null
    }
  ]
}
